export default class careerModel {
    constructor({id, positions, created_by_name, is_active, description}) {
        this.id = id;
        this.positions = positions;
        this.deskripsi = description;
        this.created_by_name = created_by_name;
        this.status= is_active;        
    }
}